o2.LP = window.LP || {
    "name": "名称",
    "description": "描述",
    "searchKey": "请输入搜索关键字",
    "desktop_style": "桌面风格",
    "flat_style": "扁平风格",
    "cmsName" : "内容管理",
    "processName" : "流程管理",
    "portalName" : "门户管理",
    "serviceName" : "服务管理"
};

o2.LP.process = {
    "unnamed": "未命名",
    "unknow": "未知",
    "processConfig": "流程配置",
    "formConfig": "表单配置",

    "createCategory": "创建分类",
    "searchCategory": "搜索分类",
    "noCategoryNotice": "现在还没有流程分类，您可以点击此处创建一个流程分类",
    "noProcessNoticeNode": "此分类现在还没有流程，您可以点击此处创建一个流程",

    "activity": "活动",
    "route": "路由",
    "property": "属性",
    "showJson": "查看JSON",
    "unrealized": "此功能未实现",
    "tools": "工具",
    "repetitions": "重复的属性名称",
    "repetitionsValue": "重复的内容项",
    "repetitionsEvent": "重复的事件名称",
    "repetitionsId": "重复的元素标识符",
    "repetitionsOrUnvalid": "重复或者无效的属性名称",
    "notNullId": "元素标识符不能为空",
    "editCategory": "编辑分类",
    "createProcess": "新建流程",
    "deleteCategory": "删除分类",
    "deleteProcess": "删除流程",
    "editProcess": "编辑流程",
    "createForm": "新建表单",
    "deleteForm": "删除表单",
    "editForm": "编辑表单",

    "menu": {
        "newRoute": "新建路由",
        "newActivity": "新建活动",
        "newActivityType": {
            "manual": "人工活动",
            "condition": "条件活动",
            "auto": "自动活动",
            "split": "拆分活动",
            "merge": "合并活动",
            "embed": "子流程活动",
            "invoke": "调用活动",
            "begin": "开始活动",
            "end": "结束活动"
        },

        "copyActivity": "复制活动",

        "deleteActivity": "删除活动",
        "deleteRoute": "删除路由",

        "saveProcess": "保存流程",
        "saveProcessNew": "保存为新版本",
        "checkProcess": "检查流程",
        "exportProcess": "导出流程",
        "printProcess": "打印流程",

        "showGrid": "显示网格",
        "hideGrid": "隐藏网格"
    },
    "notice": {
        "save_success": "流程保存成功！",
        "deleteForm_success": "表单已删除！",
        "deleteProcess_success": "流程已删除！",
        "one_begin": "每个流程只能有一个开始活动！",
        "deleteRoute": "您确定要删除选中的路由吗？",
        "deleteRouteTitle": "删除路由确认",
        "deleteActivityTitle": "删除活动确认",
        "deleteActivity": "删除活动将同时删除关联此活动的所有路由，您确定要删除选中的活动吗？",
        "deleteDecisionTitle": "删除决策确认",
        "deleteDecision": "您确定要删除选中的决策吗？",
        "deleteScriptTitle": "删除脚本确认",
        "deleteScript": "您确定要删除当前脚本吗？",
        "deleteElementTitle": "删除表单元素确认",
        "deleteElement": "是否确定删除当前元素，及其子元素吗？",
        "deleteEventTitle": "删除事件确认",
        "deleteEvent": "是否确定删除当前事件吗？",

        "deleteActionTitle": "删除操作确认",
        "deleteAction": "是否确定删除当前操作吗？",

        "deleteRowTitle": "删除表格行确认",
        "deleteRow": "删除当前行将删除该行所有单元格中的内容，是否确定删除当前选中的行？",
        "deleteColTitle": "删除表格列确认",
        "deleteCol": "删除当前行将删除该列所有单元格中的内容，是否确定删除当前选中的列？",

        "deleteProcessTitle": "删除流程确认",
        "deleteProcess": "是否确定要删除当前流程？",

        "deleteFormTitle": "删除表单确认",
        "deleteForm": "是否确定要删除当前表单？",

        "deleteTreeNodeTitle": "删除节点确认",
        "deleteTreeNode": "是否确定要删除当前节点？",

        "inputScriptName": "请输入脚本名称!",
        "inputCategoryName": "请输入分类名称!"
    },
    "button": {
        "ok": "确定",
        "cancel": "取消",
        "reset": "重置"
    },
    "formAction": {
        "insertRow": "插入行",
        "insertCol": "插入列",
        "deleteRow": "删除行",
        "deleteCol": "删除列",
        "mergerCell": "合并单元格",
        "splitCell": "拆分单元格",
        "move": "移动",
        "copy": "复制",
        "delete": "删除",
        "add": "添加",
        "script": "脚本",
        "clickScript": "点击事件脚本",
        "defaultNode": "默认节点"
    }
};
o2.LP.desktop = {
    "homepage": "首页",
    "taskCenter": "办公中心",
    "info": "信息平台",
    "calendar": "日程安排",
    "profile": "个人设置",
    "loadding": "正在为您加载系统资源，请稍候......",
    "lowBrowser": "您的浏览器版本过低啦！~系统已经不支持IE8及以下版本了!",
    "upgradeBrowser": "请升级您的浏览器：",

    "menuAction": "菜单",
    "configAction": "配置您的工作台",
    "userMenu": "用户选项",
    "userChat": "用户设置",
    "styleAction": "切换主题",
    "showDesktop": "显示桌面",
    "showMessage": "消息",
    "logout": "注销",
    "safeLogout": "安全注销",
    "safeLogoutTitle": "安全注销确认",
    "safeLogoutMessage": "安全注销将会退出您在所有设备的登陆状态，包括移动端和其他浏览器，是否确定安全注销?",
    "userConfig": "个人设置",
    "userLanguage": "语言设置",
    "application": "组件",
    "widget": "小工具",
    "process": "应用",
    "nosign": "未编辑个性签名",
    "searchUser": "搜索：用户名",
    "say": "说",
    "clearMessage": "清除消息",
    "returnZoom": "恢复100%比例",

    "refresh": "刷新",
    "close": "关闭",
    "closeAll": "全部关闭",
    "closeOther": "关闭其他",
    "openInBrowser": "新窗口打开",

    "lnkAppTitle": "常用应用",
    "deleteLnk": "删除常用应用快捷方式",
    "addLnk": "添加常用应用快捷方式",

    "changeViewTitle": "切换视图样式确认",
    "changeView": "您确定要切换视图样式吗？<br><br>如果您选择“确定”，页面将直接刷新，未保存的数据可能丢失。",
    "refreshMenu": "恢复默认菜单排序",
    "defaultMenuTitle": "恢复默认菜单确认",
    "defaultMenuInfor": "您确定要将菜单的排序和分组，恢复到默认状态码？",

    "deleteLink" : "删除快捷方式",

    "messsage": {
        "appliction": "应用",
        "application": "应用",
        "process": "流程",
        "infor": "信息",
        "query": "数据",
        "taskMessage": "待办提醒",
        "receiveTask": "您收到一条待办，标题为：",
        "activity": "活动",

        "readMessage": "待阅提醒",
        "receiveRead": "您收到一条待阅，标题为：",

        "reviewMessage": "阅读提醒",
        "receiveReview": "您收到一条阅读提醒，标题为：",

        "fileEditorMessage": "收到文件",
        "receiveFileEditor": "发送给您一个文件：",

        "fileShareMessage": "共享文件",
        "receiveFileShare": "共享给您一个文件：",

        "meetingInviteMessage": "会议邀请",
        "meetingInvite": "<font style='color: #ea621f'>{person}</font> 邀请您 于<font style='color: #ea621f'>{date}</font>参加会议：“{subject}”，地点：<font style='color: #ea621f'>{addr}</font>",
        "meetingCancelMessage": "会议取消",
        "meetingCancel": "<font style='color: #ea621f'>{person}</font> 取消了原定于<font style='color: #ea621f'>{date}</font>在<font style='color: #ea621f'>{addr}</font>举行的会议: “{subject}”",
        "meetingAcceptMessage": "会议邀请已被接受",
        "meetingAccept": "<font style='color: #ea621f'>{person}</font> 已接受您的会议邀请，将于<font style='color: #ea621f'>{date}</font>到<font style='color: #ea621f'>{addr}</font>参加会议: “{subject}”",
        "meetingRejectMessage": "会议邀请已被拒绝",
        "meetingReject": "<font style='color: #ea621f'>{person}</font> 已拒绝您的会议邀请。会议时间：<font style='color: #ea621f'>{date}</font>；会议标题: “{subject}”",

        "meetingDeleteInviteMessage": "会议邀请已取消",
        "meetingDeleteInvite": "<font style='color: #ea621f'>{person}</font> 取消了您的会议邀请，会议信息：时间<font style='color: #ea621f'>{date}</font>，标题“{subject}”，地点<font style='color: #ea621f'>{addr}</font>",

        "attendanceAppealInviteMessage": "有考勤申述需要您审批",
        "attendanceAppealInvite": "{subject}",
        "attendanceAppealAcceptMessage": "考勤申述通过",
        "attendanceAppealAccept": "{subject}",
        "attendanceAppealRejectMessage": "考勤申述未通过",
        "attendanceAppealReject": "{subject}",

        "canlendarAlarmMessage" : "日程提醒",
        "canlendarAlarm" : "{title}",

        "teamwork":{
            "executor":"责任人",
            "creatorPerson":"创建者"
        },

        "publishDocument" : "发布文档：",

        "customMessageTitle": "消息提醒：",
        "customMessage": "您收到一条消息",
        "emoji": "表情",
        "processWork": "工作",
        "cmsDoc": "信息文档",

        "bbsReplyCreateMessage" : "论坛回复提醒",
        "bbsReplyCreate": "{title}"
    },
    "styleMenu": {
        "default": "默认",
        "color": "色彩",
        "black": "酷黑",
        "lotus": "荷花",
        "crane": "仙鹤",
        "peony": "牡丹",
        "car": "老爷车",
        "dock": "码头",
        "panda": "熊猫",
        "star": "星空"
    },
    "styleFlatMenu": {
        "blue": "蓝色",
        "red": "红色",
        "orange": "水果橙",
        "green": "青草绿",
        "cyan": "碧水青",
        "purple": "魅力紫",
        "gray": "沉稳灰",
        "darkgreen": "墨绿",
        "tan": "棕色",
        "navy": "藏青"
    },
    "notice": {
        "unload": "如果关闭或刷新当前页面，未保存的内容会丢失，请确定您的操作",
        "changePassword": "您的密码已过期，请及时修改密码",
        "errorConnectCenter1": "无法连接到应用中心服务器，请确保下列地址其中之一可以访问：",
        "errorConnectCenter2": "如果以上地址都无法访问，请检查您的网络，或联系管理员！"
    },
    "login": {
        "title": "用户登录",
        "loginButton": "登　录",

        "mobileDownload": "手机扫描二维码安装",

        "inputUsernamePassword": "请输入用户名和密码...",
        "loginWait": "登录中, 请稍候...",
        "loginError": "用户名或密码输入有误, 请重新输入...",

        "camera_logining": "正在为您登录，请正对摄像头 ...",
        "camera_logining_1": "请保持微笑 ...",
        "camera_logining_2": "请抬头 ...",
        "camera_logining_3": "验证成功 ...",

        "camera_logining2": "请移动不同角度，或变换表情 ...",
        "camera_loginSuccess": "{name}您好，正在为您登录 ...",
        "camera_loginError": "无法验证您的身份，请通过其他方式登录 ...",
        "camera_loginError2": "登录失败，请通过其他方式登录 ...",
        "camera_loginError_camera": "无法打开摄像头，可能已经在使用中 ..."
    },

    "action": {
        "uploadTitle": "正在上传",
        "uploadComplete": "上传完成",
        "sendReady": "正在编码数据，准备传输 . . .",
        "sendStart": "开始传输",
        "sendError": "文件传输出现错误",
        "sendAbort": "文件传输已被取消",
        "speed": "速度",
        "time": "耗时",
        "hour": "时",
        "minute": "分",
        "second": "秒",

        "cancelUploadTitle": "取消上传确认",
        "cancelUpload": "您确定要取消上传文件“{name}”吗？"
    },
    "person": {
        "personEmployee": "人员工号",
        "personMobile": "手机",
        "personMail": "邮件",
        "personDuty": "职务",
        "personQQ": "QQ号码",
        "personWeixin": "微信",
        "duty": "职务"
    },
    "collect": {
        "collectNotConnected": "连接O2云失败",
        "collectNotConnectedText": "无法连接到O2云，请检查服务器网络！"
    }
};
o2.LP.desktop.message = o2.LP.desktop.messsage;
o2.LP.widget = {
    "upload": "上传",
    "uploadTitle": "上传文件",
    "uploadInfor": "请选择要上传的文件",
    "delete": "删除",
    "previewAtt" : "预览",
    "editAtt" : "编辑",
    "replace": "替换",
    "select": "选择",

    "download": "下载",
    "share": "分享",
    "send": "发送",
    "downloadAll": "全部下载",
    "downloadBatch": "批量下载",
    "createFolder": "创建文件夹",
    "rename": "重命名",
    "property": "属性",
    "refuseUpload": "禁止文件上传",
    "refuseUploadHTML": "<div>名为：<font style='color:#0000ff'>“{filename}”</font>的附件不符合允许上传类型，<font style='color:#ff0000'>已经被剔除</font></div>",
    "refuseUploadNotice" : "文件：“{filename}”不符合允许上传类型",
    "refuseUploadHTML_size" : "<div>名为：<font style='color:#0000ff'>“{filename}”</font>的附件超出允许的大小，<font style='color:#ff0000'>已经被剔除</font>（仅允许上传小于{size}M的文件）</div>",
    "refuseUploadNotice_size": "文件：“{filename}”超出允许的大小，（仅允许上传小于{size}M的文件）",
    "notUploadNotice": "当前状态不允许上传附件",

    "list": "列表",
    "sequence": "序列",
    "icon": "图标",
    "preview": "预览",


    "min": "简洁模式",
    "max": "完整模式",

    "size": "大小",
    "uploader": "上传人",
    "uploadTime": "时间",
    "modifyTime": "修改",
    "uploadActivity": "活动",
    "attCount": "文件",
    "folderCount": "文件夹",

    "pictureSize": "图片显示宽{width}像素,高{height}像素",
    "pictureRatio": "图片宽高比为{ratio}",

    "ok": "确定",
    "cancel": "取消",
    "refresh": "刷新",
    "close": "关闭",
    "open": "打开",
    "choiceWork": "请选择一个文档打开",
    "workcompleted": "流转完成",

    "months": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    "days_abbr": ["日", "一", "二", "三", "四", "五", "六"],
    "clear": "清除",
    "year": "年",
    "month": "月",
    "date": "日",
    "hour": "时",
    "minute": "分",
    "second": "秒",
    "week": "周",
    "dateGreaterThanCurrentNotice" : "选择的日期必须大于当前日期",

    "unknow": "未知",
    "uploadImg": "上传图片",
    "clearImg": "清除图片",
    "clearImg_confirmTitle": "清除图片确认",
    "clearImg_confirm": "您确定要清除图片吗？",
    "office": "在文档控件中打开",
    "closeOffice": "关闭附件",
    "configAttachment": "设置附件权限",
    "configAttachmentText": "设置",
    "checkOcrText": "纠正自动识别的图片中的文字",
    "order": "附件排序",

    "record": "录音",
    "stop": "停止",
    "play": "播放",
    "save": "保存",
    "userRefuse" : "用户拒绝提供信息。",
    "explorerNotSupportDevice" : "浏览器不支持硬件设备。",
    "canNotFindDevice": "无法发现指定的硬件设备。",
    "canNotOpenMicrophone": "无法打开麦克风。异常信息：",
    "explorerNotSupportRecordVoice" : "浏览器不支持录音功能。",

    "clickToEditCss" : "点击此处，编写CSS",
    "uploadSuccess": "上传成功！",
    "uploadFail": "上传失败，请重新上传！",
    "selectLocalImage" : "选择本地图片",
    "selectCloudImage": "选择云文件图片",
    "reset": "重置",
    "uploadOriginalImage": "上传原图",

    "startRecord" : "开始录制",
    "completeRecord": "结束录制",
    "requireHttps" : "视频录制功能需要用在 https 协议下才能使用",
    "canNotToRecordVideo" : "视频录制功能不能使用，您的浏览器不支持以下特性:",

    "pageJumperTitle": "输入页码，离开输入框或按回车跳转",

    "scriptAreaEditNotice" : "点击此处，编写脚本代码",
    "empty" : "清空",
    "undo" : "撤销",
    "redo" : "重做",
    "eraserRadius": "橡皮大小",
    "eraser": "橡皮",
    "input": "输入法",
    "pen": "笔画",
    "thickness" : "粗细",
    "color" : "颜色",
    "insertImage" : "插入图片",
    "imageClipper" : "裁剪图片",
    "fontSize": "字体大小",
    "fontFamily": "字体",

    "explorerNotSupportFeatures" : "您的浏览器不支持以下特性:",

    "unit": "组织",
    "duty": "职务",
    "selectIdentity": "选择身份"
};

o2.LP.widget.SimpleEditor = {
    "insertEmotion": "插入表情",
    "insertImage": "插入图像",
    "Emotions": "regular_smile|微笑，teeth_smile|大笑,angry_smile|生气,confused_smile|迷惑,cry_smile|大哭,embaressed_smile|尴尬,omg_smile|吃惊,sad_smile|难过,shades_smile|装酷,tounge_smile|吐舌,wink_smile|眨眼,angel_smile|天使,devil_smile|魔鬼,heart|红心,broken_heart|心碎,thumbs_up|顶,thumbs_down|踩,cake|蛋糕,lightbulb|灯泡,envelope|信封"
};
o2.LP.authentication = {
    "LoginFormTitle": "欢迎登录",
    "SignUpFormTitle": "欢迎注册",
    "ResetPasswordFormTitle": "找回密码",
    "ChangePasswordFormTitle" : "密码已过期",
    "userName": "用户名",
    "password": "密码",
    "verificationCode": "验证码",
    "loginAction": "登录",
    "autoLogin": "下次自动登陆",
    "signUp": "注册",
    "forgetPassword": "忘记密码？",
    "inputYourUserName": "请输入用户名",
    "inputYourPassword": "请输入密码",
    "inputYourMail": "请输入您的邮箱地址",
    "inputYourMobile": "请输入您的手机号码",
    "inputPicVerificationCode": "请输入右侧的验证码",
    "inputComfirmPassword": "请确认您的密码",
    "inputVerificationCode": "请输入手机验证码",
    "return": "返回",
    "confirmPassword": "确认密码",
    "sendVerification": "发送验证码",
    "resendVerification": "重新发送",
    "passwordIsSimple": "请使用数字字母混合且至少7位",
    "mobileIsRegisted": "手机号码已经被注册",
    "mailFormatError": "请输入正确格式的邮件地址",
    "hasAccount": "已有账号？",
    "gotoLogin": "去登录",
    "weak": "弱",
    "middle": "中",
    "high": "强",
    "userExist": "用户已经存在",
    "userNotExist": "用户不存在",
    "passwordNotEqual": "密码与上面不一致，请重新输入",
    "changeVerification": "换一张",
    "mail": "邮件",
    "genderType": "性别",
    "genderTypeText": ",男,女",
    "genderTypeValue": ",m,f",
    "selectGenderType": "请选择性别",
    "registeSuccess": "注册成功",
    "codeLogin": "短信验证登录",
    "passwordLogin": "密码登录",
    "bindLogin": "二维码登录",
    "bingLoginTitle": "手机扫码，安全登录",
    "o2downloadLink": "https://sample.o2oa.net/app/download.html",
    "loginSuccess": "登录成功！",
    "userCheck": "用户认证",
    "shotMessageCheck": "短信验证",
    "setMewPassword": "设置新密码",
    "completed": "完成",
    "nextStep": "下一步",
    "mobile": "手机",
    "setNewPassword": "设置新密码",
    "confirmNewPassword": "确认新密码",
    "passwordIsWeak": "密码太弱，请使用数字和字母，且长度大于7",
    "resetPasswordSuccess": "重置密码成功！",
    "resetPasswordFail": "重置密码失败！",
    "resetPasswordSuccessWord": "请牢记您新设置的密码。",
    "resetPasswordFailWord": "请核对您的用户名和短信验证码。",
    "backtoModify": "返回修改",
    "pageNotFound": "404错误，未找到服务或服务器已断开",
    "submitAction" : "确定",
    "oldPassword" : "原密码",
    "inputYourOldPassword" : "请输入原密码",
    "newPassword" : "新密码",
    "inputYourNewPassword" : "请输入新密码",
    "changePasswordSuccess" : "修改密码成功",
    "userAppCameraHtml" : "<div>打开<div styles='bindTipLinkArea'>APP</div>扫一扫</div>",
    "loginToPage": "登录网页版",
    "accessError": "访问后台服务失败"

};
o2.LP.script = {
    "error": "脚本运行错误，请查看以下详细信息"
};

MWF.xApplication = MWF.xApplication || {};
MWF.xApplication.process = MWF.xApplication.process || {};
MWF.xApplication.process.Work = MWF.xApplication.process.Work || {};
MWF.xApplication.process.Work.LP = {
	"title": "工作",
    "selectRoute": "选择决策",
    "inputOpinion": "填写意见",
    "selectPerson" : "选择人员",
    "cancel": "取 消",
    "ok": "提 交",
    "close": "关　闭",
    "saveWrite": "保　存",
    "inputText": "请在此处填写流程意见",

    "mustSelectRoute": "请先选择决策",
    "mustSelectRouteGroup" : "请先选择决策组",
    "opinionRequired" : "请填写意见",

    "searchKey": "请输入关键字",

    "task": "待办中心",
    "done": "已办中心",
    "draft": "草稿箱",
    "myfile": "我的文件",
    "reset": "重置处理人",
    "reroute": "调度",
    "addSplit": "增加分支",
    "rollback": "流程回溯",
    "goBack": "退回",

    "phone": "手机",
    "mail": "邮箱",
    "save": "保存",
    "process": "继续流转",
    "flowWork": "继续流转",
    "handwriting": "手写",
    "audioRecord": "录音",

    "noAppendTaskIdentityConfig" : "没有配置转交人，请联系管理员",
    "selectAppendTaskIdentityNotice" : "请选择转交人",
    "routeValidFailure" : "路由校验失败",
    "loadedOrgCountUnexpected" : "人员选择界面未加载完成，请稍候...",

    "taskCompletedPerson": "办理人",
    "readPerson": "阅读人",
    "systemFlow": "系统自动处理",

    "openWorkError": "您没有权限查看该文档或该文档已删除。",

    "rollbackConfirmTitle": "流程回溯确认",
    "rollbackConfirmContent": "您确定要将流程回溯到“{log}”状态吗？（流程回溯会清除此状态之后的所有信息）",
    "rollbackSuccess" : "回溯成功",

    "recoverFileConfirmTitle": "恢复正文确认",
    "recoverFileConfirmContent": "您确定要将正文恢复到 “{att}”版本吗？（恢复后，已保存的临时文件将被删除，您无法再次恢复）",

    "notRecoverFileConfirmTitle": "取消正文恢复确认",
    "notRecoverFileConfirmContent": "您确定要取消正文恢复吗？（取消后，已保存的临时文件将被删除，您无法再次恢复）",

    "closePageCountDownText" : "将在“{second}”秒后关闭页面！",
    "closePage" : "关闭页面",

    "selectRouteGroup" : "选择决策组",
    "defaultDecisionOpinionName" : "其它",
    "routeGroupOrderList" : ["同意","不同意","其它","其他"],

    "selectWork": "您要打开的文件已形成多个分支，请选择其中一个查看：",
    "currentActivity": "当前活动: ",
    "currentUsers": "当前处理人: ",
    "completedWork": "文件已流转完成",

    "managerProcessNotice" : "注：快速处理功能适用于以下情况，否则可能出错：<br\>1、表单中已填好必填项。<br\>2、不需要在提交时选择人员。<br\>3、没有基于用户身份计算的内容。<br\>您是管理员，可以模拟待办人登录后在表单上提交，点击下面的链接执行。",
    "managerLogin" : "模拟登录并打开文件",
    "managerLoginConfirmTitle" : "模拟登陆",
    "managerLoginConfirmContent" : "确定要以{user}身份登录并打开文件？点击确定后，需注销重新登录才能回到当前用户。",
    "managerLoginSuccess" : "已成功切换为{user}",

    "selectIdentity": "选择办理此待办的身份",
    "selectIdentityInfo": "检测到当前工作您有多个不同身份的待办，请选择一个身份处理此工作",

    "org": "组织",
    "duty": "职务",

    "flowActions": {
        "addTask": "加签",
        "reset": "重置",
        "process": "提交",
        "goBack": "退回"
    },
    "modeType": "处理方式",
    "single": "单人",
    "queue": "串行",
    "parallel": "并行",
    "addTaskType": "加签方式",
    "addTaskBefore": "前加签",
    "addTaskAfter": "后加签",
    "opinion": "意见",
    "addTaskPerson": "加签人",
    "inputOpinionNote": "请在此处填写意见",
    "inputAddTaskPeople": "请选择加签人",
    "inputResetPeople": "请选择重置人",
    "inputAddTaskType": "请选择加签方式",
    "inputModeType": "请选择处理方式",
    "resetTo": "重置给",
    "keepTask": "保留我的待办",
    "quickSelect": "快速选择",
    "empowerTo": "授权给",
    "selectAll": "全选",
    "ok1": "确定",
    "not": "不",
    "selectPerson1": "请选择人员",
    "noQuickSelectDataNote": "系统还未记录您在当前节点选择的数据。",
    "submitQuickText": "选择[{route}]，意见：{opinion}{org}。",
    "addTaskQuickText": "选择[{route}{mode}]，意见：{opinion}，加签人：{org}。",
    "resetQuickText": "意见：{opinion}，重置给：{org}。",

    "users": "处理人",
    "goBackActivity": "退回到活动",
    "goBackActivityWay": "退回后处理：",
    "goBackActivityWayStep": "按流程正常流转",
    "goBackActivityWayJump": "直接回到退回人",
    "goBackTo": "退回到：",
    "selectGoBackActivity": "请选择要退回的活动"
};
MWF.xApplication.process.Work["lp."+o2.language] = MWF.xApplication.process.Work.LP;

MWF.xApplication.process = MWF.xApplication.process || {};
MWF.xApplication.process.Xform = MWF.xApplication.process.Xform || {};
MWF.xApplication.process.Xform.LP = {
    "ok": "确定",
	"deleteDatagridLineTitle":"删除条目确认",
    "deleteDatagridLine": "是否确定要删除当前条目？",

    "cancelDatagridLineEditTitle" : "取消编辑数据网格确认",
    "cancelDatagridLineEdit" : "是否确定取消编辑数据网格？",

    "datagridImport" : "导入Excel",
    "datagridExport" : "导出Excel",
    "exportDefaultName" : "数据网格",
    "datatemplateExportDefaultName": "数据模板",
    "datatableExportDefaultName": "数据表格",
    "importSuccess" : "导入成功！",
    "validationInfor" : "校验信息",
    "importFail" : "导入失败",
    "importValidationColumnText" : "第{n}列：",
    "importValidationColumnTextExcel" : "列{n}：",
    "notValidNumber" : "不是数字",
    "notValidDate" : "不是日期格式",
    "fullstop" : "。",
    "notExistInSystem" : "在系统中不存在",
    "uploadedFilesCannotHaveSpaces" : "上传的文件不能带空格",

    "browserNotActiveX": "您的浏览器不支持ActiveX控件，不能加载Office控件，请使用IE浏览器",

    "activity": "活动",
    "dataSaved": "数据保存成功",
    "taskProcessed": "文件已提交",
    "taskProcessedMessage": "您处理了一个待办任务：",
    "nextActivity": "下一个活动：",
    "nextUser": "处理人：",
    "arrivedActivitys": "到达活动",
    "arrivedUsers": "到达处理人",
    "replace": "代",
    "next_etc": "等{count}人",

    "nextTaskMatrix": "可能的后续处理人: ",

    "processStarted": "文件已启动",
    "processStartedMessage": "您启动了一个新的工作：",

    "draftStart": "流程已启动",

    "taskCompleted": "待办已处理",
    "workCompleted": "工作流转已完成",
    "arrivedActivity": "工作已到达活动：",
    "workProcess": "继续流转",
    "close": "关闭",
    "retract": "撤回",
    "reroute": "调度",
    "rerouteTo": "调度到",
    "rollback": "流程回溯",
    "rollbackTo": "流程回溯到",
    "rollback_success" : "回溯成功",
    "selectRollbackActivity" : "请选择文件要回溯到的位置：",
    "tryToProcess" : "并尝试继续流转",
    "in": "在",

    "andSoForth" : "等",

    "noIdentitySelectRange" : "无法确定身份的选择范围",
    "noIdentityDutySelectRange" : "无法确定职务的选择范围",
    "noUnitSelectRange" : "无法确定组织的选择范围",
    "noSelectRange": "无法确定选择范围",
    "noSelectType": "未设置选择类型",
    "selectRoute": "选择路由",
    "submitAt": "提交于",
    "idea": "意见",
    "processing": "正在处理",
    "comeTime": "到达时间",
    "begin": "起",
    "end": "止",
    "none": "无",
    "empower": "授权",

    "person": "处理人",
    "department": "部门",
    "startTime": "收到时间",
    "completedTime": "处理时间",
    "route": "路由",
    "opinion": "意见",

    "systemProcess": "系统处理",
    "showProcess": "显示流程图",

    "deleteAttachmentTitle":"删除附件确认",
    "deleteAttachment": "是否确定要删除您选中的附件？",

    "sendTaskNotice" : "已经向待办人：{users}, 发送了提醒",
    "setReadedConfirmContent" : "您确定要将“{title}”标记为已阅吗？",
    "setReadedConfirmTitle" : "标记已阅确认",

    "replaceAttachmentTitle":"替换附件确认",
    "replaceAttachment": "是否确定要替换您选中的附件？",
    "uploadMore": "您最多只允许上传 {n} 个附件",
    "notValidation": "数据校验未通过",
    "lineNotValidation": "行数据校验未通过",
    "notValidation_number": "必须输入数字",
    "notAttachmentValidation": "附件校验未通过。",

    "retractTitle": "撤回确认",
    "retractText": "您确认要撤回此文件吗？",
    "workRetract": "文件已撤回",
    "retractWorkInfor": "您撤回了文件：",


    "currentActivity": "当前活动：",
    "currentUser": "处理人：",

    "inputResetPeople": "请选择要重置给的人员！",
    "resetTo": "重置给",
    "reset": "重置",
    "resetOk": "文件已重置给",
    "workReset": "文件已重置",
    "resetWorkInfor": "您重置了文件：",

    "system": "System",

    "workRollback": "文件已回溯",
    "rollbackOk": "文件已回溯给",
    "rollbackWorkInfor": "您回溯了文件：",

    "workReroute": "文件已调度",
    "rerouteWorkInfor": "您调度了文件：",
    "rerouteOk": "文件已调度到：",

    "inputSplitValue": "请输入或选择增加分支的依据值",
    "addSplitOk": "已经增加处理分支：",
    "addSplitWork": "已经增加处理分支",
    "addSplitWorkInfor": "您已为当前工作增加了分支",

    "deleteWorkTitle": "删除文件确认",
    "deleteWorkText": {"html": "<div style='color: red;'>注意：您正在删除此文档，删除后文档无法找回，请您确认要删除此文件吗？</div>", "text": "注意：您正在删除此文档，删除后文档无法找回，请您确认要删除此文件吗？"},
    "workDelete": "已经删除文件",

    "terminateWorkTitle": "终止文件",
    "terminateWorkText": "终止文件表示此文件被废弃，直接结束流转，确定要执行？",
    "workTerminate": "已经终止文件",
    "terminateWork": "终止文件",

    "amount": "▌总计",
    "sectionAmount": "▌小计",
    "delete": "删除",
    "add": "新增",
    "addLine": "添加新条目",
    "edit": "编辑",
    "completedEdit": "完成",
    "cancelEdit": "取消",
    "mobileGridHelp": "长按数据区域可编辑数据<br>向左滑动可以删除数据",
    "item": "▌条目",
    "all": "全部",
    "imageClipper" : "图片编辑",
    "noOrgObject": "未匹配人员或组织，点击可修改",

    "menu_revisions_show": "显示痕迹",
    "menu_revisions_hide": "隐藏痕迹",
    "menu_fullscreen": "全屏模式",
    "menu_toolbar_show": "显示工具栏",
    "menu_toolbar_hide": "隐藏工具栏",
    "menu_preview": "打印预览",
    "menu_redfile": "套红",
    "menu_seal": "盖章",
    "menu_showHistory": "查看历史版本",
    "menu_hideHistory": "关闭历史版本",
    "menu_new": "新建文档",
    "menu_openfile": "打开本地文件",
    "menu_savefile": "保存到本地",
    "menu_att": "查看附件",
    "menu_file": "打开正文",
    "completed": "结束",
    "openOfficeInfor": "点击此处打开{type}文件",
    "seeVersion" : "查看版本",
    "selectVersionToRestore" : "请选择要恢复的正文版本：",
    "restoreFile" : "恢复正文",
    "installNTKOWebChromePluginNotice_xpi" : "尚未安装NTKO Web Chrome跨浏览器插件。请点击<a href=\"../o2_lib/officecontrol/ntkoplugins.xpi\">安装组件</a>",
    "installNTKOWebChromePluginNotice_crx" : "尚未安装NTKO Web Chrome跨浏览器插件。请点击<a href=\"../o2_lib/officecontrol/ntkoplugins.crx\">安装组件</a>",

    "showReadCompletedTitle": "已阅人",
    "showReadTitle": "待阅人",
    "worklogRead": "查看待阅",
    "mediaOpinion_image": "手写意见",
    "mediaOpinion_video": "视频意见",
    "mediaOpinion_voice": "语音意见",

    "attachmentPermission": "设置附件权限",
    "attachmentPermissionInfo": "您正在为以下附件设置权限：",
    "attachmentRead": "谁可以查看和下载此附件：(为空表示有权限阅读此文档的人都可以，不为空需同时选择编辑和设置权限)",
    "attachmentEdit": "谁可以编辑此附件：(为空表示有权限编辑此文档的人都可以，不为空需同时选择设置权限)",
    "attachmentController": "谁可以设置此附件的权限：(为空表示有权限编辑此文档的人都可以)",

    "attachmentSecurity": "附件密级标识",

    "attachmentOCRTitle": "纠正自动识别的图片中的文字",
    "attachmentOCR_saved": "图像文字识别结果已保存",

    "attachmentOrderTitle": "附件排序",
    "attachmentOrderUp": "上移",
    "attachmentOrderDown": "下移",
    "attachmentOrderInfo": "拖动附件图标，或通过“下移”、“下移”按钮对附件进行排序",

    "autosave": "自动保存文档",

    "ignore": "忽略",
    "ANNInput": "智能输入建议值：",

    "recover": "恢复正文",
    "notRecover": "取消正文恢复",

    "doublePage": "双页",
    "singlePage": "单页",
    "editdoc": "编辑正文",
    "editdocCompleted": "编辑完成",
    "printdoc": "打印正文",
    "history": "正文痕迹审查",
    "handwrittenApproval": "手写签批",
    "fullScreen": "全屏",
    "returnScreen": "还原",

    "editdoc_mobile": "编辑",
    "editdocCompleted_mobile": "编辑完成",
    "printdoc_mobile": "打印",
    "history_mobile": "痕迹",
    "handwrittenApproval_mobile": "签批",


    "subformNestedError" : "该表单存在相互嵌套的子表单，请联系管理员！",
    "subpageNestedError" : "该页面存在相互嵌套的子页面，请联系管理员！",

    "subformUniqueError" : "该表单重复嵌入了同一子表单，请联系管理员！",
    "moduleUniqueError" : "该表单存在重名的字段，请联系管理员！",

    "selectEmpower" : "授权人员替换选择",
    "empowerDlgText" : "下列人员对工作进行了授权，选择后文件将发送给被授权人，取消选择后文件将发送给授权者本人",
    "empowerTo" : "授权给",
    "empowerToHtml" : "<font style='color:#ff5400;'>{person}</font>（{department}）授权给<font style='color:#ff5400;'>{empowerTo}</font>处理。（{time}）</font>",
    "autoFlowHtml" : "系统自动提交于：{time}",
    "systemSubmit": "系统自动处理",
    "selectAll" : "全选",
    "computePage": "正在计算分页，请稍候……",
    "keyLockTitle": "文件编辑已锁定",
    "keyLockInfor": "文件正由 {name} 编辑处理，您可以查看文件内容，稍后可刷新页面重试。",

    "year" : "年",
    "month" : "月",
    "date" : "日",

    "documentEditor": {
        "copies": "",
        "secret":"",
        "priority": "",
        "redHeader": "文件红头",
        "fileno":"[文号]",
        "signerTitle": "签发人：",
        "signer": "[签发人]",
        "subject": "[标题]",
        "mainSend": "[主送单位：]",
        "filetext": "[请在此处编辑正文内容]",
        "attachmentTitle":"附件：",
        "attachment":"[附件]",
        "issuanceUnit":"[发文机关]",
        "issuanceDate":"[成文日期]",
        "annotation":"",
        "copytoTitle":"抄送：",
        "copyto":"[抄送]",
        "editionUnit":"[印发机关]",
        "editionDate":"[印发日期]",
        "historyList": "历史版本文档",
        "attachmentInfor": "[点击此处编辑附件内容]"
    },
    "documentHistory": {
        "diffContent": "<div>{time}</div>{name} 在 ”{activity}“ 时修改的内容",
        "insertContent": "<div>{time}</div>{name} 在 ”{activity}“ 时插入的内容:",
        "deleteContent": "<div>{time}</div>{name} 在 ”{activity}“ 时删除的内容:",
        "insert": "插入了",
        "delete": "删除了",
        "insertTimes": "插入了 {times} 处",
        "deleteTimes": "删除了 {times} 处",
        "play": "修改记录回放",
        "pause": "暂停回放",
        "stop": "停止修改记录回放",
        "next": "下一个修改记录",
        "prev": "上一个修改记录",
        "exit": "退出痕迹审查",
        "diff_patch_count": "共有{history}个历史版本，{diff}处修订。",
        "original": "原始版本",
        "nodiff": "目前还没有历史修改信息",
        "word": "字",
        "diff": "对比",
        "diffTitle": "与上一版本对比",
        "showAll": "显示所有痕迹"
    },
    "subjectEmpty": "标题不能为空",
    "issuanceUnitEmpty": "发文单位不能为空",
    "fullWidth": "已启用半角空格自动转换为全角空格，如需输入半角空格，请使用：SHIFT+空格",

    "pauseWork": "当前待办已进入挂起状态",
    "resumeWork": "当前待办已从挂起状态中恢复",

    "resume": "挂起恢复",
    "pause": "挂起",

    "selectItemCountNotice" : "请至少选择{count}项",
    "setReaded" : "标记为已阅",
    "readed" : "已阅",

    "attachmentArea": "附件区域",
    "intelligentCorrection" : "智能纠错",

    "requiredHint": "请填写{label}字段",
    "requiredHintField": "此",

    "maxItemCountNotice": "最多允许添加{n}项",
    "selectItemNotice": "请先选择条目",
    "minItemNotice": "最少需要保留{n}项，删除后的条目小于需保留的条目，请检查",
    "deleteSelectedItemNotice": "确定要删除选中的条目",
    "minItemCountNotice": "请最少保留{n}项",
    "systemField": "系统字段",
    "systemFieldEmptyNotice": "系统字段不能为空",
    "importTooManyNotice": "本次导入了{n1}条数据，最多允许导入{n2}条数据",
    "importTooFewNotice": "本次导入了{n1}条数据，最少需要保留{n2}条数据",

    "pleaseSelect": "请选择",

    "form": {
        "close":"关闭",
        "closeTitle": "关闭文档",
        "save": "保存",
        "saveTitle": "保存文档",
        "flow": "继续流转",
        "flowTitle": "继续流转文档",
        "process": "继续流转",
        "processTitle": "继续流转文档",
        "submit": "提交",
        "submitTitle": "提交文档",
        "reroute": "调度",
        "rerouteTitle": "调度文档",
        "reset": "重置处理人",
        "resetTitle": "重置处理人",
        "split": "增加分支",
        "splitTitle": "增加拆分分支",
        "retract": "撤回",
        "retractTitle": "待办撤回",
        "rollback": "流程回溯",
        "rollbackTitle": "回溯到指定的环节，不保留流程记录",
        "delete": "删除文档",
        "deleteTitle": "删除文件",
        "terminate": "终止文件",
        "terminateTitle": "结束文件流转",
        "print": "打印",
        "printTitle": "打印文档",
        "press": "催促办理",
        "pressTitle": "催促办理",
        "pause": "挂起",
        "pauseTitle": "待办挂起",
        "resume": "挂起恢复",
        "resumeTitle": "从挂起状态恢复",
        "downloadAll": "一键下载",
        "downloadAllTitle": "一键下载",
        "monitor": "流程监控",
        "monitorTitle": "流程监控",
        "addTask": "加签",
        "addTaskTitle": "在当前活动添加处理人",

        "goBack": "退回",
        "goBackTitle": "退回到已经过的活动",

        "rerouteActivity": "调度到：",
        "reroutePerson": "调度给：",
        "selectPerson": "选择人员",
        "retouteOpinion": "调度意见：",

        "resetPerson": "重置给：",
        "resetOpinion": "重置意见：",
        "keepTask": "保留我的待办",

        "readedOpinion": "阅读意见",

        "setReaded" : "标记为已阅",
        "readed" : "已阅",

        "rollbackInfo": "请选择文件要回溯到的位置",
        "addSplitInfo": "根据您的业务设置拆分数据，此处设置的数据应与流程中设置的拆分依据匹配。多个值请用半角逗号(,)分隔",
        "splitValue": "拆分依据",
        "opinion": "意见",
        "selectUnit": "选择组织或人员",
        "excludeBranches": "排除已有分支",
        "yes": "是",
        "no": "否",

        "readIdentity": "待阅人",
        "sendReadNotify": "发送待阅通知",

        "reviewIdentity": "阅读人",
        "noTaskToReset": "当前工作没有您的待办，不能执行该操作",

        "addTaskPerson": "加签人",
        "addTaskOpinion": "意　见",
        "addTaskBefore": "前加签",
        "addTaskAfter": "后加签",
        "addTaskBeforeTitle": "在您处理之前添加处理人",
        "addTaskAfterTitle": "在您处理之后添加处理人",
        "addTaskType": "加签方式",
        "modeType": "处理方式",
        "single": "单人",
        "queue": "串行",
        "parallel": "并行",

        "goBackActivity": "退回到活动：",
        "goBackActivityWay": "退回后处理：",

        "goBackActivityWayStep": "按流程正常流转",
        "goBackActivityWayJump": "直接回到退回人",
        "goBackTo": "退回到：",

        "selectGoBackActivity": "请选择要退回的活动",


        "addTaskRepeatedTitle": "重复加签提醒",
        "addTaskRepeatedInfo": "<span class='mainColor_color'><b>{repeated}</b></span> 已经在处理人列表中，不会对其执行加签。",

        "mergeWork": "合并工作"
    },

    "sendRead": "发送待阅",
    "sendReadOk": "已经发送待阅",
    "noPermissionOrWorkNotExisted": "您没有权限或者工作不存在",
    "inputSendReadPeople": "请选择待阅人",
    "sendReadPeopleCanNotEmpty": "待阅人不能为空",

    "sendReview": "添加阅读人",
    "sendReviewOk": "已添加阅读人",
    "inputSendReviewPeople": "请选择阅读人",
    "sendReviewPeopleCanNotEmpty": "阅读人不能为空",
    "inputAddTaskPeople": "请选择加签人",
    "addTaskOk": "已添加加签人",
    "addTaskInfor": "您加签了文件：",

    "applicationNotFound": "未找到应用",

    "pdfview" : {
        "nofile" : "暂无文件，请上传",
        "upload" : "上传"
    },
    "ofdview" : {
        "nofile" : "暂无文件，请上传",
        "upload" : "上传"
    },
    "onlyoffice" : {
        "noInstall" : "请先安装onlyoffice应用",
        "filetext" : "文件正文"
    },
    "officeonline" : {
        "noInstall" : "请先安装officeonline应用",
        "filetext" : "文件正文"
    },
    "title": "标题",
    "createTime": "创建时间",
    "creatorPerson": "创建人",
    "creatorUnit": "创建组织",
    "score": "关联度",
    "updateTime": "更新时间",

    "documentType": "文档类型",
    "processName": "流程名称",
    "draftTime": "拟稿时间",
    "draftPerson": "拟稿人",
    "categoryName": "分类",
    "publishPerson": "发布人",
    "publishTime": "发布时间",
    "document": "信息",
    "work": "工作",
    "cancelAssociatedTitle": "取消关联文档",
    "cancelAssociated": "确定要取消和文档“{title}”的关联?",
    "associatedResult": "关联结果",
    "selectDocNote": "请先选择文档",
    "associatedDocument": "关联文档",
    "docDeleted": "文档已经被删除或您没有权限打开此文档。",

    "uploading": "正在上传附件，请等待附件上传完成后再执行此操作。"

};
MWF.xApplication.process.Xform["lp."+o2.language] = MWF.xApplication.process.Xform.LP;

MWF.xApplication.Selector=MWF.xApplication.Selector||{};
MWF.xApplication.Selector.LP = MWF.SelectorLP = {
    "title": "选择",
    "multiSelectTitle": "选择",
    "selectPerson": "选择人员",
    "selectIdentity": "选择身份",
    "selectUnit": "选择组织",
    "selectGroup": "选择群组",
    "selectRole": "选择角色",
    "selectDuty": "选择职务",
    "selectField": "选择字段",
    "selectFile": "选择资源文件",
    "selectAppliction": "选择流程应用",
    "selectProcess": "选择流程",
    "selectView": "选择视图",
    "selectStatement" : "选择查询",
    "selectTable": "选择数据表",
    "selectList" : "选择列表",
    "selectFormStyle" : "选择表单样式",
    "selectCMSApplication": "选择内容管理应用",
    "selectCMSCategory": "选择内容管理栏目",
    "noSelectableItemText" : "无待选项",
    "selectScript" : "选择脚本",
    "selectDictionary" : "选择数据字典",
    "selectImportModel": "选择导入模型",
    "selectFieldProperty": "选择字段属性",

    "searchDescription" : "搜索内容",
    "searchDescriptionFieldProperty": "展开过的表单可以搜索组件",

    "waitingSelect" : "待选",
    "selected" : "已选",
    "empty" : "清空",
    "remove": "移除",
    "selected2": "已选择",

    "identity" : "身份",
    "person" : "个人",
    "duty" : "职务",
    "application" : "应用",
    "CMSApplication" : "应用",
    "CMSCategory" : "分类",
    "CMSFormField" : "字段",
    "formField" : "字段",
    "process" : "流程",
    "role" : "角色",
    "group" : "群组",
    "unit" : "组织",
    "systemList" : "系统列表",

    "quantifier": {
        "person": "个人",
        "identity": "身份",
        "unit": "组织",
        "group": "群组",
        "role": "角色"
    },

    "appType" : {
        "process": "流程管理",
        "cms": "内容管理",
        "portal": "门户管理",
        "service": "服务管理",
        "currentForm": "当前表单"
    },

    "cancel": "取消",
    "back": "返回",
    "ok": "确定",
    "noPerson": "人员“{name}”不存在",

    "processPlatform": "流程平台",
    "cms": "内容管理",
    "portal": "门户管理",
    "query": "数据中心",
    "service": "服务管理",
    "currentForm": "当前表单",

    "systemStyle" : "系统样式",
    "customStyle" : "自定义样式（脚本）",
    "selectAll" : "全选",
    "selectChildren" : "全选下级",
    "selectItemMaxText" : "最多可选择{count}个选项",
    "service1" : "服务",
    "agent" : "代理"
};
MWF.xApplication.Selector["lp."+o2.language] = MWF.xApplication.Selector.LP;

o2.xApplication.Template = o2.xApplication.Template || {};
o2.xApplication.Template.LP = {
	"title": "模板",
	"delete" : "删除",
	"deleteDocumentTitle": "删除确认",
	"deleteDocument": "您确定要删除该信息吗?",
	"deleteDocumentOK": "删除成功",
	"createSuccess" : "创建成功",
	"updateSuccess" : "更新成功",
	"inputName" : "请输入名称",

	"dateFormatMonth": "%Y年%m月",
	"dateFormatOnlyMonth": "%m",
	"dateFormatDay": "%Y-%m-%d",
	"dateFormatMonthDayLocal": "%m月%d日",
	"dateFormat": "db",

	"month" : "月",
	"today" : "今天",
	"day" : "天",

	"cancel" : "取消",
	"ok" : "确定",

	"name" : "姓名",
	"create_cancel_title": "取消新建确认",
	"create_cancel": "您确定要取消新建吗?",

	"index" : {

	},

	"explorer" : {
		"returnText" : "返回首页",
		"pageJumperText": "输入页码，按回车跳转",
		"prePage" : "上一页",
		"nextPage": "下一页"
	},

	"MDomItem" : {
		"emptyTip": "{text}不能为空",
		"emailTip":"请输入正确格式的电子邮件",
		"urlTip":"请输入合法的网址",
		"phoneNumberTip" :"请输入正确的手机号码",
		"dateTip":"请输入合法的日期",
		"dateISOTip":"请输入合法的日期 .",
		"numberTip":"请输入合法的数字",
		"digitsTip":"只能输入整数",
		"maxlengthTip":"长度不能超过{n}",
		"minlengthTip":"长度不能小于{n}",
		"rangelengthTip":"长度不能要介于{n0}和{n1}之间" ,
		"rangeTip":"请输入一个介于{n0}和{n1}之间的值" ,
		"minTip":"请输入一个最小为{n}的值" ,
		"maxTip":"请输入一个最大为{n}的值" ,
		"extensionTip":"请上传{text}格式的附件" ,
		"defaultTip" :"请输入正确的{text}",
		"selectTip": "请先选择{text}",
		"defaultOption": "请选择",
		"setPicture": "设置图片",
		"uploadPictureNotice" : "请先上传图片",
		"selectCoundPicture": "选择云文件图片"
	},

	"MGrid" : {
		"sequence" : "序号",
		"add": "添加",
		"delete": "删除",
		"addMaxLimitText": "最多只能添加{count}项"
	},

	"MPopupForm" : {
		"close": "关闭",
		"max": "最大化",
		"restore": "还原"
	},

	"excelUtils": {
		"promptTitle": '输入提示',
		"prompt": '请从下拉列表中选择一个值',
		"errorTitle": '输入错误',
		"error": '你输入的值不在列表中'
	}
};
MWF.xApplication.portal = MWF.xApplication.portal || {};
MWF.xApplication.portal.Portal = MWF.xApplication.portal.Portal || {};
MWF.xApplication.portal.Portal.LP = {
	"title": "门户"
};
MWF.xApplication.portal.Portal["lp."+o2.language] = MWF.xApplication.portal.Portal.LP;

MWF.xApplication.cms = MWF.xApplication.cms || {};
MWF.xApplication.cms.Document = MWF.xApplication.cms.Document || {};
MWF.xApplication.cms.Document.LP = {
	"title": "文档",
    "selectRoute": "选择决策",
    "inputOpinion": "填写意见",
    "comfirm" : "确认",
    "close" : "关闭",
    "cancel": "取 消",
    "ok": "提 交",
    "inputText": "请在此处填写流程意见",

    "mustSelectRoute": "请先选择决策",

    "searchKey": "请输入关键字",

    "task": "待办中心",
    "done": "已办中心",
    "draft": "草稿箱",
    "myfile": "我的文件",
    "reset": "重置处理人",

    "phone": "手机",
    "mail": "邮箱",

    "documentGettedError" : "您没有权限查看该文档或该文档已删除。",
    "controllerGettedError" : "管理员获取错误",
    "formGettedError" : "表单获取错误",
    "attachmentGettedError" : "附件获取错误",
    "formNotSetted" : "未设置表单",

    "attachmentArea" : "附件区域",
    "selectAttachment" : "选择附件",

    "hotPicture" : "热点图片",
    "cancelHotPicture" : "取消热点",
    "setHotPicture" : "设置热点",
    "regularPublish": "定时发布",
    "publishTime": "发布时间",
    "publish": "发布",
    "inputPublishTime": "发布时间不能为空",
    "inputPublishTime2": "发布时间不能早于当前时间",
    "setHotLinkSuccess" : "设置热点图片成功",
    "cancelHotLinkSuccess" : "取消热点图片成功",
    "selectDocPicture" : "选择文档图片",
    "selectFilePicture" : "选择云文件图片",
    "hotLinkDescription" : "注：选择的图片将作为本平台移动端APP的顶部图片，图片的最佳高宽比为1:2",
    "unselectHotPic" : "请先选择图片",
    "cancelHotPicComfirmTitle" : "取消热点",
    "cancelHotPicComfirmContent" : "确定取消该文档的热点？"
};
MWF.xApplication.cms.Document["lp."+o2.language] = MWF.xApplication.cms.Document.LP;

MWF.xApplication.process = MWF.xApplication.process || {};
MWF.xApplication.process.Xform = MWF.xApplication.process.Xform || {};
MWF.xDesktop.requireApp("process.Xform", "lp."+MWF.language, null, false);
MWF.xApplication.cms = MWF.xApplication.cms || {};
MWF.xApplication.cms.Xform = MWF.xApplication.cms.Xform || {};
MWF.xApplication.cms.Xform.LP = Object.merge({}, MWF.xApplication.process.Xform.LP, {
    "dataSaved": "数据保存成功",
    "documentPublished" : "发布成功" ,
    "documentDelayedPublished": "定时发布成功",

    "noSelectRange": "无法确定选择范围",

    "begin": "起",
    "end": "止",
    "none": "无",

    "person": "人员名称",
    "department": "单位",
    "firstDate": "首次阅读时间",
    "readDate": "最近阅读时间",
    "readCount" : "阅读次数",
    "startTime": "收到时间",
    "completedTime": "处理时间",
    "opinion": "意见",

    "systemProcess": "系统处理",

    "deleteAttachmentTitle":"删除附件确认",
    "deleteAttachment": "是否确定要删除您选中的附件？",

    "replaceAttachmentTitle":"替换附件确认",
    "replaceAttachment": "是否确定要替换您选中的附件？",
    "uploadMore": "您最多只允许上传 {n} 个附件",
    "notValidation": "数据校验未通过",

    "deleteDocumentTitle": "删除文件确认",
    "deleteDocumentText": {"html": "<div style='color: red;'>注意：您正在删除此文档，删除后文档无法找回，您确认要删除此文件？</div>"},
    "documentDelete": "已经删除文件",

    "readerFieldNotice" : "不选则全员可见",

    "readedLogTitle" : "阅读记录",
    "readedCountText" : "共{person}人、{count}次阅读",
    "defaultReadedLogText" : "<font style='color:#00F;'>{person}</font>（{department}） 阅于<font style='color:#00F'>{date}</font>，共<font style='color:#00F'>{count}</font>次",

    "commendLogTitle" : "点赞记录",
    "commendLogPerson" : "点赞人员",
    "commendLogTime" : "点赞时间",
    "commendCountText" : "共{count}次点赞",
    "defaultCommendLogText" : "<font style='color:#00F;'>{person}</font> 点赞于<font style='color:#00F'>{date}</font>",


    "reply" : "评论",
    "commentTitle" : "评论区域",
    "commentCountText" : "共{count}次评论",

    "saveComment" : "发表评论",
    "saveCommentSuccess" : "发布评论成功",
    "deleteCommentTitle" : "删除评论确认",
    "deleteCommentText" : "删除评论后不能恢复，您确定要删除此评论？",
    "deleteCommentSuccess" : "删除评论成功",
    "commentFormTitle" : "编辑评论",
    "createCommentSuccess" : "创建评论成功",
    "updateSuccess" : "更新成功",
    "save" : "保存",

    "setTopTitle": "置顶确认",
    "setTopText": "确定将当前文档置顶？",
    "setTopSuccess": "置顶成功",
    "cancelTopTitle": "取消置顶确认",
    "cancelTopText": "确定将当前文档取消置顶？",
    "cancelTopSuccess": "取消置顶成功",

    "attachmentArea" : "附件区域",
    "selectAttachment" : "选择附件",

    "yesterday" : "昨天",
    "theDayBeforeYesterday" : "前天",
    "severalWeekAgo" : "{count}周前",
    "severalDayAgo" : "{count}天前",
    "severalHourAgo" : "{count}小时前",
    "severalMintuesAgo" : "{count}分钟前",
    "justNow" : "刚才",
    "commend": {
        "do": "点赞",
        "undo": "取消点赞"
    },
    "form": {
        "close":"关闭",
        "closeTitle": "关闭文档",
        "edit": "编辑",
        "editTitle": "编辑文档",
        "save": "保存",
        "saveTitle": "保存文档",
        "publish": "发布",
        "publishTitle": "发布文档",
        "publishDelayed": "定时发布",
        "publishDelayedTitle": "定时发布文档",
        "saveDraft": "保存草稿",
        "saveDraftTitle": "保存草稿",
        "popular": "设置热点",
        "popularTitle": "设置热点",
        "delete": "删除",
        "deleteTitle": "删除文档",
        "print": "打印",
        "printTitle": "打印文档",
        "setTop": "置顶",
        "setTopTitle": "对文档置顶",
        "cancelTop": "取消置顶",
        "cancelTopTitle": "取消对文档的置顶"
    }

    //"at" : "阅于",
    //"readdDocument" : "，",
    //"historyRead" : "共",
    //"times" : "次"
});
MWF.xApplication.cms.Xform["lp."+o2.language] = MWF.xApplication.cms.Xform.LP;
